/* Nightform — storefront behaviour.
   Everything here is progressive. With this file blocked the page still reads,
   and the buy box falls back to the <noscript> variant select, which posts a
   real variant id to /cart/add. The hidden id input stays disabled until this
   script enables it, so the two can never both submit.

   1. Carousel arrows, injected rather than hard-coded, so a rail with one slide
      never shows dead controls.
   2. Variant selection across two options: a price ladder and colour swatches.
   3. Re-runs on shopify:section:load so the theme editor stays live. */
(function () {
  function rails(root) {
    root.querySelectorAll('.nf .rail').forEach(function (rail) {
      if (rail.dataset.bound) return;
      rail.dataset.bound = '1';
      if (rail.children.length < 2) return;

      var nav = document.createElement('div');
      nav.className = 'railnav';
      nav.innerHTML =
        '<button type="button" aria-label="Previous"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" aria-label="Next"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5l7 7-7 7"/></svg></button>';
      rail.parentNode.insertBefore(nav, rail);
      var b = nav.querySelectorAll('button');

      function step(dir) {
        var c = rail.firstElementChild;
        if (!c) return;
        rail.scrollBy({ left: dir * (c.getBoundingClientRect().width + 16), behavior: 'smooth' });
      }
      b[0].addEventListener('click', function () { step(-1); });
      b[1].addEventListener('click', function () { step(1); });

      function sync() {
        b[0].disabled = rail.scrollLeft < 4;
        b[1].disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 4;
        nav.style.display = rail.scrollWidth <= rail.clientWidth + 4 ? 'none' : '';
      }
      rail.addEventListener('scroll', sync);
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function buybox(root) {
    root.querySelectorAll('.nf form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';

      var scope = form.closest('.prod') || form.parentNode;
      var data = scope.querySelector('.nf-vardata');
      var idInput = form.querySelector('.nf-varid');
      if (!data || !idInput) return;

      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      if (!variants || !variants.length) return;

      /* the script is running, so the hidden input is the one that submits
         and the <noscript> select was never rendered */
      idInput.disabled = false;

      var tiers = form.querySelector('.tiers');
      var swatches = form.querySelector('.swatches');
      var swName = form.querySelector('.nf-swname');

      function chosen(box) {
        if (!box) return null;
        var r = box.querySelector('input[type=radio]:checked');
        return r ? r.value : null;
      }

      function match(a, b) {
        return variants.filter(function (v) {
          return (a === null || v.o.indexOf(a) > -1) && (b === null || v.o.indexOf(b) > -1);
        })[0] || null;
      }

      function apply() {
        var t = chosen(tiers), c = chosen(swatches);
        var v = match(t, c);
        if (v) idInput.value = v.id;

        if (tiers) {
          tiers.querySelectorAll('.tier').forEach(function (el) {
            var r = el.querySelector('input[type=radio]');
            el.classList.toggle('tier--on', !!r && r.checked);
          });
        }
        if (swatches) {
          swatches.querySelectorAll('.sw').forEach(function (el) {
            var r = el.querySelector('input[type=radio]');
            el.classList.toggle('sw--on', !!r && r.checked);
            /* grey out a colour that is unavailable in the chosen tier */
            var combo = r ? match(t, r.value) : null;
            el.classList.toggle('sw--out', !!combo && combo.av === false);
          });
          if (swName && c) swName.textContent = c;
        }
      }

      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') apply();
      });
      apply();
    });
  }

  function boot(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    rails(root);
    buybox(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
